import lazyPage from "../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/pages/plan/ModeratorBar/ModeratorBar.tsx",
    () => import("./ModeratorBar"),
);
